import axios, { AxiosError } from 'axios'

import { URL } from '@/shared/constants/common'
import { ERR_CODE } from '@/shared/constants/errCode'
import Utils from '@/shared/utils'
import { captureServerError, captureUnexpectedErrCode } from '@/shared/utils/sentry/api'
import { addApiBreadcrumb } from '@/shared/utils/sentry/breadcrumb'

class BaseApiService {
  hostURL: string = window.location.host
  private readonly url: string = this.hostURL.includes('dev')
    ? URL.DEV.REST
    : this.hostURL.includes('localhost')
      ? URL.DEV.REST
      : URL.PRO.REST
  async requestServer<T>(
    requestData: RequestHttp<RequestBodys>,
  ): Promise<AxiosCustomResponseType<T>> {
    addApiBreadcrumb('request', { cmdType: requestData.Header.CmdType })

    return await axios
      .post(this.url, JSON.stringify(requestData), { withCredentials: true })
      .then((response) => {
        const { Header } = response.data

        if (Header.ErrCode !== ERR_CODE.SUCCESS) {
          addApiBreadcrumb('response', {
            cmdType: Header.CmdType,
            errCode: Header.ErrCode,
            errMsg: Header.ErrMsg,
          })
          captureUnexpectedErrCode(Header)
        }
        return response
      })
      .catch((error: AxiosError) => {
        captureServerError(error, requestData.Header.CmdType)
        if (error.response != null) {
          // console.log(error.response.data)
          // console.log(error.response.status)
          // console.log(error.response.headers)
        }
        if (error.request) {
          // console.log(error.request)
        } else {
          console.error('Error', error.message)
        }
        // console.log(error.config)
      })
  }

  responseErrorHandler<T>(result: AxiosCustomResponseType<T>): T {
    const { data } = result
    // console.log(data)
    const { Header, Body } = data
    switch (Header.ErrCode) {
      default:
        return Body
    }
  }
}

class AutocallApiService extends BaseApiService {
  setHttpData(
    CmdType: CmdType,
    TransactionID: string,
    Body: RequestBodys,
  ): RequestHttp<RequestBodys> {
    return {
      Header: {
        CmdType,
        TransactionID,
        Browser: 'chrome',
        CallApp: 'www',
        LocalIP: '192.168.15.199',
      },
      Body,
    }
  }

  async requestSRS<T>(CmdType: CmdType, Body: RequestBodys) {
    try {
      return this.responseErrorHandler<T>(
        await this.requestServer<T>(this.setHttpData(CmdType, Utils.common.getGUID(), Body)),
      )
    } catch (e) {
      console.error(e)
    }
  }
}

export default AutocallApiService

export function httpData(CmdType: CmdType, Body?: RequestBodys) {
  return {
    Header: {
      CmdType,
      TransactionID: Utils.common.getGUID(),
      Browser: 'chrome',
      CallApp: 'www',
      LocalIP: '192.168.15.199',
    },
    Body: Body != null && Body,
  }
}

export async function restServer(httpData: any) {
  const hostServer =
    window.location.host.includes('dev') || window.location.host.includes('local')
      ? 'https://dev-srs.autocall.ai'
      : 'https://n-srs.autocall.ai'
  return await axios
    .post(hostServer, JSON.stringify(httpData), { withCredentials: true })
    .then((response) => {
      const { Header } = response.data
      if (Header.ErrCode !== ERR_CODE.SUCCESS) {
        addApiBreadcrumb('response', {
          cmdType: Header.CmdType,
          errCode: Header.ErrCode,
          errMsg: Header.ErrMsg,
        })
        captureUnexpectedErrCode(Header)
      }
      return response
    })
    .catch((error: AxiosError) => {
      captureServerError(error, httpData?.Header?.CmdType)
      throw error
    })
}

export const hostServer = () => {
  if (window.location.host.includes('dev') || window.location.host.includes('local')) {
    return 'https://dev-srs.autocall.ai'
  } else {
    return 'https://n-srs.autocall.ai'
  }
}
